import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import remoteServices from '~/constants/RemoteServices';
import {rfeCredentialsHeader} from '~/utils/http';

export const mmsApi = createApi({
  reducerPath: 'mmsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${remoteServices.products}/api/out`,
    credentials: rfeCredentialsHeader
  }),
  endpoints: builder => ({
    getMatchingColors: builder.query({
      query: ({styleId, colorId, complementIds}) => ({
        url: `/styles/${styleId}/colors/${colorId}/match.json`,
        method: 'GET',
        params: {style_ids: complementIds.join(',')}
      })
    })
  })
});

export const {useGetMatchingColorsQuery} = mmsApi;
